module.exports = __webpack_public_path__ + "img/EG.7490f14a.png";